import React from "react";
import ChooseGadgetPages from "../components/GadgetProtection/Choosegadgetpages";
import banner1 from "../assets/Banner/WebBanner/b2.png";
import Header from "../layout/Header";

const GadgetProtection = () => {
  return (
    <>
      <div className="relative w-full h-screen flex flex-col mt-0 top-0">
        <img
          src={banner1}
          alt="About Us Banner"
          className="w-full h-full object-fill absolute top-0 left-0 z-0"
        />

        <div className="absolute top-0 left-0 w-full z-20">
          <Header />
        </div>

        <div className="flex flex-1 items-center justify-center relative z-10" 
        style={{
          background:'linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)',
          opacity:'0.9',
        }}
        >
          <ChooseGadgetPages />
        </div>
      </div>
    </>
  );
};

export default GadgetProtection;
